export default {
  methods: {
    rulesCurrency: v => /^\d+(\.\d{1,2})?$/.test(v) || !v || "Invalid Amount",
    rulesEmail: v => /\S+@\S+\.\S+/.test(v) || !v || "E-mail must be valid",
    rulesEmailList: v =>
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+(\s*[,.]\s*(\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3}))+\s*)*$/.test(
        v
      ) ||
      !v ||
      "E-mails must be separated by a comma and be a valid E-mail.",
    rulesInteger: v =>
      !isNaN(parseInt((v + "").replace(/,/g, ""))) ||
      !v ||
      "Must be an Integer",
    rulesParcelshieldUserEmail: v =>
      /^\w+([.-]?\w+)*@?(sunagosystems|parcelshield|dawsonhcs)\.com$/.test(v) ||
      !v ||
      "Must be a valid company E-mail",
    rulesPhone: v =>
      /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im.test(v) ||
      !v ||
      "Must be a US phone number",
    rulesProperDecimal: v => v < 1 || !v || "Must be Less Than 1",
    rulesRequired: v =>
      ((v + "").trim().length > 0 && (!!v || v === 0)) || "Required",
    rulesTimeAmPm: v => /^\d{2}:\d{2}\s(AM|PM)$/.test(v) || "Invalid Time",
    rulesValidHours: v =>
      /^(\d{1,5}|\d{0,5}\.\d{1,2})$/.test(v) || !v || "Invalid",
    rulesWhiteSpace: v =>
      (v + "").trim() == v || "Remove Leading or Trailing Spaces",
    rulesZip: v => /^\d{5}$/.test(v) || !v || "Zip code must be valid"
  }
};
